import { render } from "./CDataTable.vue?vue&type=template&id=c40bc2fa"
import script from "./CDataTable.vue?vue&type=script&lang=js"
export * from "./CDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__